export const INVOICE_GET_INVOICES_BEGIN = 'INVOICE_GET_INVOICES_BEGIN';
export const INVOICE_GET_INVOICES_SUCCESS = 'INVOICE_GET_INVOICES_SUCCESS';
export const INVOICE_GET_INVOICES_FAILURE = 'INVOICE_GET_INVOICES_FAILURE';
export const INVOICE_GET_INVOICES_DISMISS_ERROR = 'INVOICE_GET_INVOICES_DISMISS_ERROR';
export const INVOICE_GET_INVOICE_BEGIN = 'INVOICE_GET_INVOICE_BEGIN';
export const INVOICE_GET_INVOICE_SUCCESS = 'INVOICE_GET_INVOICE_SUCCESS';
export const INVOICE_GET_INVOICE_FAILURE = 'INVOICE_GET_INVOICE_FAILURE';
export const INVOICE_GET_INVOICE_DISMISS_ERROR = 'INVOICE_GET_INVOICE_DISMISS_ERROR';
